var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    {
      attrs: {
        overlap: _vm.overlap,
        small: _vm.small,
        transparent: _vm.transparent,
        stretched: _vm.stretched,
        slimmer: _vm.slimmer
      }
    },
    [
      !!_vm.inputLabel
        ? _c(
            "label",
            { attrs: { slot: "label", for: _vm.inputName }, slot: "label" },
            [_vm._v("\n\n    " + _vm._s(_vm.inputLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.getInnerStyle, attrs: { slot: "input" }, slot: "input" },
        [
          _c("input-tag", {
            attrs: {
              addTagOnKeys: [32, 13, 188, 9],
              id: _vm.identification,
              name: _vm.inputName,
              tags: _vm.tags,
              placeholder: _vm.inputPlaceholder,
              "on-change": _vm.sendUpdate()
            },
            on: {
              "update:tags": [
                function($event) {
                  _vm.tags = $event
                },
                function($event) {
                  return _vm.sendUpdate()
                }
              ]
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa48ecc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa48ecc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputTags.vue
// module id = null
// module chunks = 